// Thin wrapper around the `cryptocurrency-icons` npm package. Uses the
// `color` SVGs in 128px; webpack 5 asset modules turn these into hashed URLs.
//
// Falls back to the bundled "generic" icon for anything we haven't mapped.

// Preload a curated slice of the 500+ icons so `iconForSymbol('btc')` is
// synchronous and we do not need dynamic imports at render time.
import btc     from "cryptocurrency-icons/svg/color/btc.svg";
import eth     from "cryptocurrency-icons/svg/color/eth.svg";
import usdt    from "cryptocurrency-icons/svg/color/usdt.svg";
import usdc    from "cryptocurrency-icons/svg/color/usdc.svg";
import xmr     from "cryptocurrency-icons/svg/color/xmr.svg";
import ltc     from "cryptocurrency-icons/svg/color/ltc.svg";
import doge    from "cryptocurrency-icons/svg/color/doge.svg";
import trx     from "cryptocurrency-icons/svg/color/trx.svg";
import bch     from "cryptocurrency-icons/svg/color/bch.svg";
import sol     from "cryptocurrency-icons/svg/color/sol.svg";
import xrp     from "cryptocurrency-icons/svg/color/xrp.svg";
import bnb     from "cryptocurrency-icons/svg/color/bnb.svg";
import ada     from "cryptocurrency-icons/svg/color/ada.svg";
import dot     from "cryptocurrency-icons/svg/color/dot.svg";
import dash    from "cryptocurrency-icons/svg/color/dash.svg";
import matic   from "cryptocurrency-icons/svg/color/matic.svg";
import usd     from "cryptocurrency-icons/svg/color/usd.svg";
import eur     from "cryptocurrency-icons/svg/color/eur.svg";
import gbp     from "cryptocurrency-icons/svg/color/gbp.svg";
import generic from "cryptocurrency-icons/svg/color/generic.svg";

const REGISTRY: Record<string, string> = {
  btc, eth, usdt, usdc, xmr, ltc, doge, trx, bch, sol, xrp, bnb, ada, dot,
  dash, matic, usd, eur, gbp, generic
};

export const iconForSymbol = (symbol: string): string => {
  const key = symbol.toLowerCase();
  return REGISTRY[key] ?? generic;
};
